import CollapsibleItem from './collapsible';

export default () => {
  if (!document.getElementsByClassName('accordion')) {
    return false;
  }

  new CollapsibleItem('.accordion__item');
};
